import { CSSProperties } from 'react';
import { Booking } from '@/types';
import { getAccessibleOutlineColor, hexToRgba } from '@/lib/color-utils';

/** Status key used for cancelled bookings across the app. */
export const CANCELLED_STATUS = 'cancelled';

export function isCancelledStatus(status?: string | null): boolean {
  return String(status ?? '').toLowerCase() === CANCELLED_STATUS;
}

export function isCancelledBooking(booking: Pick<Booking, 'status'>): boolean {
  return isCancelledStatus(booking.status);
}

/**
 * Translucent fill derived from the configured cancelled colour so the tile
 * reads as an outline rather than a solid block.
 */
export function getCancelledFill(color: string): string {
  return hexToRgba(color, 0.15);
}

/**
 * Dashed-outline colour for a cancelled booking. Derived from the configured
 * cancelled colour but darkened (or lightened) when that colour on its own
 * wouldn't be visible against the row behind the tile.
 */
export function getCancelledOutlineColor(color: string): string {
  return getAccessibleOutlineColor(color);
}

/**
 * Visual treatment for a cancelled booking tile: dashed outline in the
 * configured cancelled colour, faded fill and struck-through label.
 */
export function getCancelledBlockStyle(color: string): CSSProperties {
  return {
    backgroundColor: getCancelledFill(color),
    border: `2px dashed ${getCancelledOutlineColor(color)}`,
    textDecoration: 'line-through',
  };
}
